export default {"src":"/uk/_next/static/media/spot-village.47947e3a.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};